import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { AppFormGrid } from "@components"
import { dsColorNew } from "@palette"
import { UploadCsvButton, UploadCsvTemplate } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { ReportFormDrawerCsvTable } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Csv"
import { useUploadCsv } from "Pages/ReportsAlerts/Reports/@hooks"


export default function ReportFormDrawerCsvSection() {

	const { data, onDownload, onDelete, onSubmit } = useUploadCsv()

	return <AppFormGrid>
		<Box sx={{
			gridColumn: '1 / -1', display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap',
			p: 2, borderRadius: '12px', border: `1.5px dashed ${dsColorNew.grayBorder}`, backgroundColor: dsColorNew.tableRowAlt,
		}}>
			<Box sx={{ width: 40, height: 40, borderRadius: '10px', flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: dsColorNew.pillActiveBg, color: dsColorNew.appBlue }}>
				<IconSeeker icon="file-csv" sx={{ fontSize: 18 }}/>
			</Box>
			<Box sx={{ flex: 1, minWidth: 220 }}>
				<Typography sx={{ fontSize: 14, fontWeight: 600, color: dsColorNew.textTitle }}>Searches from a CSV file</Typography>
				<Typography sx={{ fontSize: 13, color: dsColorNew.textMuted }}>Upload a CSV with the searches to run. Use the example as a template.</Typography>
			</Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
				<UploadCsvTemplate/>
				<UploadCsvButton {...data} onSubmit={onSubmit}/>
			</Box>
		</Box>
		<Box sx={{ gridColumn: '1 / -1' }}>
			<ReportFormDrawerCsvTable {...data} onDownload={onDownload} onDelete={onDelete}/>
		</Box>
	</AppFormGrid>
}
